import { PublicProfileTypeEnum } from '@on-arte/core-types';
import React from 'react';

import { BaseViewWithBio } from '@onArte/frontend/components';
import { RouteNameEnum } from '@onArte/shared/enums';

export const CollectorDetailsView: React.FC = (): JSX.Element => {
  return <BaseViewWithBio type={PublicProfileTypeEnum.Collector} route={RouteNameEnum.CollectorDetails} />;
};
